const vaperdeals = {
    id: 'vaperdeals',
    publicSiteName: 'Vaper Deals',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#ed0616',
            secondary: '#000000',
            color1: '#d1404a',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'minimal',
            dark: true,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/vaperdeals/favicon.ico',
        logo: '/vaperdeals/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default vaperdeals